<app-vvr-icon [full]="false" [dark]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Materialen mallen</h1>
        </div>
        <div class="controls">
            <div id="btn-Exit" class="fab small" routerLink="/management"
                 matTooltip="Terug naar overzicht"
                 matTooltipPosition="below">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-12 col-md-9 col-xl-7">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th (click)="sortList('name')">
                            Naam <i
                            [class.fa-sort-down]="!desc() && currentSort() === 'name'"
                            [class.fa-sort-up]="desc() && currentSort() === 'name'"
                            [class.fa-sort]="currentSort() !== 'name'"
                            class="fas"></i>
                        </th>
                        @if (AuthorisationService.hasFeature('deleteMoldMaterial')) {
                            <th class="trash-column" width="20">
                            </th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (material of materials(); track material) {
                        <tr
                            (click)="edit(material)"
                            class="curpoint">
                            <td>
                                {{material.name}}
                            </td>
                            @if (AuthorisationService.hasFeature('deleteMoldMaterial')) {
                                <td class="pt-0 pb-0">
                                    <button
                                        (click)="delete($event, material)"
                                        color="warn"
                                        mat-icon-button>
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="controls-bottom">
    <div class="fab big primary" id="btn-Mapview" routerLink="/{{Routenames.ppeEquipment}}/new">
        <i class="fas fa-plus"></i>
    </div>
</div>
